import { createFileRoute } from "@tanstack/react-router";
import { buildHead, breadcrumbJsonLd, faqJsonLd, serviceJsonLd, webPageJsonLd } from "@/lib/seo";
import { setEdgeHtmlCache } from "@/lib/cache-headers";
import { HIRE_SHOPIFY_DEVELOPER_COPY } from "@/lib/hire-shopify-developer-copy";

const PATH = "/es/contratar-desarrollador-shopify";
const ALT = "/hire-shopify-developer";
const COPY = HIRE_SHOPIFY_DEVELOPER_COPY.es;

export const Route = createFileRoute("/es/contratar-desarrollador-shopify")({
  loader: async () => { await setEdgeHtmlCache(); },
  head: () => buildHead({
    locale: "es",
    title: "Contratar Desarrollador Shopify | Ingeniería Senior · Shugert",
    description: "Contrata desarrolladores Shopify senior para themes, Functions, checkout, apps, integraciones, migraciones, rendimiento y SEO técnico con staging y handoff.",
    path: PATH,
    altPath: ALT,
    jsonLd: [
      breadcrumbJsonLd([
        { name: "Inicio", path: "/es" },
        { name: "Servicios", path: "/es/servicios" },
        { name: "Contratar desarrollador Shopify", path: PATH },
      ]),
      faqJsonLd(COPY.faqs),
      serviceJsonLd({
        name: "Capacidad de Ingeniería Shopify",
        description: "Capacidad Shopify senior para trabajo recurrente o interconectado con alcance escrito, staging, verificación y handoff.",
        path: PATH,
        serviceType: "Desarrollador Shopify",
        minPrice: 1500,
        unit: "PROJECT",
        deliverables: [
          "Alcance escrito y criterios de aceptación",
          "Implementación Shopify senior",
          "QA representativo y controles de release",
          "Documentación técnica y handoff",
        ],
        locale: "es",
      }),
      webPageJsonLd({
        name: "Contratar un Desarrollador Shopify",
        path: PATH,
        description: "Incorpora capacidad de ingeniería Shopify senior sin perder ownership, control de release ni contexto técnico.",
        inLanguage: "es-MX",
      }),
    ],
  }),
});
